import ApiService from './baseApi';
import { Review, CreateReviewRequest, ClientReviewsResponse, TrendData } from '../types/review';

class ReviewApi extends ApiService {
  private endpoint = '/reviews';

  // Get reviews for a client
  async getClientReviews(clientId: string): Promise<ClientReviewsResponse> {
    // Use the protected api instance directly - the interceptor returns response.data
    // TypeScript thinks it returns AxiosResponse but the interceptor unwraps it
    const response: any = await this.api.get(`${this.endpoint}/client/${clientId}`);
    return response as ClientReviewsResponse;
  }

  // Get trend data for a client (initial assessment + review scores)
  async getTrendData(clientId: string): Promise<TrendData> {
    const response: any = await this.api.get(`${this.endpoint}/client/${clientId}/trends`);
    return response as TrendData;
  }

  // Create a new review
  async createReview(data: CreateReviewRequest): Promise<Review> {
    // Use the protected api instance directly - the interceptor returns response.data
    const response: any = await this.api.post(this.endpoint, data);
    return response as Review;
  }
}

export const reviewApi = new ReviewApi();
